import { Component } from '@angular/core';
import {NavController, NavParams, ModalController, ViewController} from 'ionic-angular';
import { NotificationProvider } from '../../../providers/notification/notification';
import { FeedFocusComponent } from '../profile/feed-focus/feed-focus.component';
import { AuthProvider } from '../../../providers/auth/auth';
import { NetworkPage } from '../network/network';
import { PollPage } from '../poll/poll';
import { MeetteamDetailsPage } from '../lunchroulette/meet-details/meet-details';
import {HomePage} from "../home/home";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  notificationList: Array<any> = [];
  currUserId:string;

  // Notification type to string
  typeString = [
    'a publié dans le newsfeed',
    'a créé un nouveau club',
    'Un nouveau sondage est disponible',
    'Vous avez un match Meetteam !',
    'a commenté votre publication',
  ]

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public notificationProvider: NotificationProvider,
    private modalCtrl: ModalController,
    private authProvider: AuthProvider,
    private viewCtrl: ViewController
     ) {
      this.currUserId = this.authProvider.user.user_id;
  }

  ionViewDidEnter() {
    this.loadNotifications();
  }

  goBack() {
    this.viewCtrl.dismiss().then(() => {});
  }

  loadNotifications() {
    this.notificationList = [];
    this.notificationProvider.getAll().subscribe((res) => {
      if(res.success){

          res.data.forEach(notification => {

            notification.user_id != this.currUserId ? this.notificationList.push(notification) : '';
          });

      }

    })
  }


  checkNotif(currNotif){
    switch (currNotif.type) {
      case 0:
          let modalFeed = this.modalCtrl.create(FeedFocusComponent, {postId: currNotif.post_id, isClubFeed: false});
          modalFeed.present().then(() => {});
        break;

      case 1:
        this.navCtrl.push(NetworkPage)
        break

      case 2:
        this.navCtrl.push(PollPage)
        break

      case 3:
        let modalMeet = this.modalCtrl.create(MeetteamDetailsPage, {meetId: currNotif.customData});
        modalMeet.present().then(() => {});
        break

      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/notifications/notifications.ts